module.exports = __webpack_public_path__ + "media/audio4.ac24f268.wav";